export default () => (
  /**
   * Icone de ponto usado em mapas.
   * Responsável por marcar pontos no mapa.
   * Encontrado na ferramenta de inserir geometrias.
   */
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.79989 6.85556C9.36656 4.28889 13.5221 4.28889 16.0888 6.85556C17.311 8.07778 17.9954 9.69111 18.0077 11.4144C18.0321 13.1256 17.3843 14.7511 16.211 15.9978L11.4321 20.7767L6.751 16.0956C4.23323 13.5289 4.25767 9.39778 6.79989 6.85556ZM5.94434 6C2.92545 9.01889 2.901 13.9078 5.89545 16.9511L11.4443 22.5L17.091 16.8533C19.9754 13.7978 19.9266 8.98222 16.9443 6C13.901 2.95667 8.98767 2.95667 5.94434 6Z"
      fill="#BEC7DC"
    />
    <circle cx="11.4443" cy="11.5" r="2.75" fill="#BEC7DC" />
  </svg>
);
